package org.zq.astrock_ai.ui.research.gushi.data

import org.zq.astrock_ai.storage.ResearchKvStorage

/** 研究台布局偏好：紧凑/宽屏强制或自动。 */
data class WorkbenchLayoutPrefs(
    /** auto | compact | wide */
    val mode: String = "auto",
)

object WorkbenchLayoutPrefsStore {
    private const val KEY = "workbench.layout.v1"

    fun load(): WorkbenchLayoutPrefs {
        val raw = ResearchKvStorage.get(KEY)?.trim().orEmpty()
        val mode = when (raw.lowercase()) {
            "compact", "wide", "auto" -> raw.lowercase()
            else -> "auto"
        }
        return WorkbenchLayoutPrefs(mode = mode)
    }

    fun save(prefs: WorkbenchLayoutPrefs) {
        val mode = when (prefs.mode.lowercase()) {
            "compact", "wide" -> prefs.mode.lowercase()
            else -> "auto"
        }
        ResearchKvStorage.put(KEY, mode)
    }

    fun cycle(current: WorkbenchLayoutPrefs): WorkbenchLayoutPrefs {
        val next = when (current.mode) {
            "auto" -> "compact"
            "compact" -> "wide"
            else -> "auto"
        }
        return WorkbenchLayoutPrefs(mode = next).also { save(it) }
    }

    fun label(prefs: WorkbenchLayoutPrefs): String = when (prefs.mode) {
        "compact" -> "紧凑"
        "wide" -> "宽屏"
        else -> "自动"
    }
}
